export type BaseOptionId = string | number;

export type SegmentedControlBaseOption<Id extends BaseOptionId = number> = {
  id: Id;
  value: string;
  dataTest?: string;
  dataGaEvent?: string;
  dataGaEventValue?: string;
};

export const enum SegmentedControlState {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

